module.exports = __webpack_public_path__ + "static/media/ocidental.e7f20376.png";